module.exports = __webpack_public_path__ + "static/media/garuda-usdc.4e3dffa7.png";